module.exports = __webpack_public_path__ + "img/happy-star-drawing.cc30d503.png";